export const contactsData = {
    email: 'rishi.rn818@gmail.com',
    phone: '8825203332',
    address: 'Patna, Bihar',

    sheetAPI: ''
}